import {Component, ViewChild} from "@angular/core";
import {Leasings} from "../../../../../../../../server/src/base/entities/leasing/Leasings";
import {IVanService} from "../../../../../domain/leasing/IVanService";
import {LeasingType} from "../../../../../../../../server/src/base/entities/leasing/LeasingType";
import {UnavailabilityComponent} from "../../../garage/leasing/presentation/unavailability/unavailability";

@Component({
    selector: 'admin-leasing-presentation',
    styleUrls: ['./presentation.scss'],
    templateUrl: './presentation.html'
})
export class AdminLeasingPresentationComponent {

    @ViewChild('unavailabilityDialog') public unavailabilityDialog:UnavailabilityComponent;

    private vanService:IVanService;

    public leasings:Leasings;
    public typeSelected:LeasingType;

    constructor(vanService: IVanService) {
        this.vanService = vanService;
        this.leasings = new Leasings();
    }

    ngOnInit(){
        this.reset();
        this.vanService.Leasings().then(leasings => {
            this.leasings = leasings;
        });
    }

    manage(type:LeasingType){
        this.typeSelected = type;
    }

    manageUnavailabilities(type:LeasingType){
        this.vanService.Vans(type).then(vans => {
            this.unavailabilityDialog.Open(vans);
        });
    }

    reset(){
        this.typeSelected = -1;
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/leasing/presentation/presentation.ts